import Footer from "./layout/Footer";
import Navlink from "./layout/Navlink";
import MainSearchInput from "./common/home/main-search-input";
import AccordionSpe from "./utils/AccordionSpe";
import AccordionStatic from "./utils/AccordionStatic";
import DetailCom from "./common/childid/DetailCom";
import CheckDetailCom from "./common/childid/CheckDetailCom";
import PaymentCom from "./common/childid/PaymentCom";
import SectionSendFile from "./common/childid/SectionSendFile";
import LoaderMain from "./loader/LoaderMain";
import HeaderMission from "./common/admission/layout/HeaderMission";
import TurnSelection from "./common/admission/layout/TurnSelection";
import Content_Roting from "./common/admission/layout/Content_Roting";
import Carousel_time_turn from "./common/admission/Carousel_time_turn";
import AboutTurnCom from "./common/aboutdoctor/AboutTurnCom";
import ProfileDoctor from "./common/aboutdoctor/ProfileDoctor";
import AboutTurn from "./common/aboutdoctor/layout/AboutTurn";
import SliderCardUi from "./common/aboutdoctor/layout/SliderCardUi";
import CarouselAboutDoctors from "./common/aboutdoctor/layout/CarouselAboutDoctors";
import ScreeningComBox from "./common/screening/ScreeningComBox";
import CardSingle_lab from "./common/sing_label/CardSingle_lab";
import SetButtonId from "./common/sing_label/SetButtonId";
import Accordions_sing_lab from "./utils/Accordions_sing_lab";
import ComboboxDemo from "./utils/ComBoxDemo";
import CustomfileInput from "./utils/CustomfileInput";
import CustomTextArea from "./utils/CustomTextArea";
import CustomFieldInput from "./utils/CustomFiledInput";
import CustomSelectOption from "./utils/CustomSelectOption";
import Additional_information_turn from "./common/childid/Additional_information_turn";
import LoginFunction from "./common/auth/LoginFunction";
import FormRegister from "./common/auth/FormRegister";
import CardSimlarDoctor from "./common/admission/CardSimlarDoctor";

// loader
import FildeSearchMorCom from "./common/home/FildeSearchMorCom";
import MenuRadio from "./common/sing_label/mobile/MenuRadio"; 
// error
import ErrorMainPages from "./Error/ErrorMainAllPage";

// dashboard

// import Dashboard_MenuRigth_layout from "../app/_(dashboards)/dahsboards/layout/Dashboard_MenuRigth_layout";
// import Dashboard_table from "../app/_(dashboards)/dahsboards/doctor/Dashboard_table";
// import Dashboard_CardNameAvatar from "../app/_(dashboards)/dahsboards/layout/Dashboard_CardNameAvatar";
// import Dashboarde_ModalAdd from "../app/_(dashboards)/dahsboards/doctor/Dashboarde_ModalAdd";
// import Dashboard_Modal_form from "../app/_(dashboards)/dahsboards/doctor/Dashboard_Modal_form";
// import Dash_doc_appointment_list_modal from "../app/_(dashboards)/dahsboards/doctor/Dash_doc_appointment_list_modal";
// import Dashboard_form_recorde_turn from "../app/_(dashboards)/dahsboards/doctor/Dashboard_form_recorde_turn";
// import Dash_Refrence_doctor from "../app/_(dashboards)/dahsboards/doctor/Dash_Refrence_doctor";
// import Dash_Refrence_lab_imaging from "../app/_(dashboards)/dahsboards/doctor/Dash_Refrence_lab_imaging";
// import Dash_navbar from "../app/_(dashboards)/dahsboards/layout/Dash_navbar";
// import Dash_doc_transactions_form from "../app/_(dashboards)/dahsboards/doctor/Dash_doc_transactions_form";
// import { DashBoxTitle } from "../app/_(dashboards)/dahsboards/utils/dah-box-link";

// import CityDoctor from "./common/home/CityDoctor";
// // dash new
// import DashTextTitle from "../app/_(dashboards)/dahsboards/doctor/setting/dash-title-text";
// import DashTurnLabelsModalAdd, { DashTurnChangeLabels } from "../app/_(dashboards)/dahsboards/doctor/setting/dash-turn-labels-modal";
// import DashSecond_officeForm from "../app/_(dashboards)/dahsboards/doctor/setting/dash-second_office-form";

export {
    // layout
    Footer,
    Navlink,
    LoaderMain,

    // home 
    FildeSearchMorCom,
    MainSearchInput as FildeSearch,

    // auth
    LoginFunction,
    FormRegister,

    // alldoctors details
    DetailCom,
    CheckDetailCom,
    PaymentCom,
    SectionSendFile,

    // doctors
    ProfileDoctor,
    AboutTurn,
    AboutTurnCom,
    AccordionSpe,
    AccordionStatic,
    SliderCardUi,
    Additional_information_turn,
    CardSimlarDoctor,

    // clinicDoctor
    HeaderMission,
    TurnSelection,
    Content_Roting,
    CarouselAboutDoctors,
    Carousel_time_turn,

    // screening
    ScreeningComBox,

    //radiology-lab
    CardSingle_lab,
    MenuRadio,
    SetButtonId,
    Accordions_sing_lab,

    // utils
    CustomfileInput,
    CustomFieldInput,
    CustomTextArea,
    CustomSelectOption, 
    // utlis_componete
    ComboboxDemo,

    // loading 
    // Error
    ErrorMainPages,

    // DASHBOARDS
    // Dashboard_MenuRigth_layout,
    // Dashboard_table,
    // Dashboarde_ModalAdd,
    // Dashboard_CardNameAvatar,
    // Dashboard_Modal_form,
    // Dash_doc_appointment_list_modal,
    // Dashboard_form_recorde_turn,
    // Dash_Refrence_doctor,
    // Dash_Refrence_lab_imaging,
    // Dash_navbar,
    // Dash_doc_transactions_form,
    // CityDoctor,
    // DashTextTitle,
    // DashTurnLabelsModalAdd,
    // DashTurnChangeLabels,
    // DashSecond_officeForm,
    // DashBoxTitle
};
